/* eslint-disable no-unused-vars */
import React, { useState, useContext } from "react";
import { useHistory, useLocation } from "react-router-dom";
import "./header.css";
import { AppBar, Grid, Divider, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Button, Tooltip } from "@material-ui/core";
import ChangeModal from "../change-modal/change-modal";
import { setAccountData } from "../../../../services/AccountInfoHandler";
import HeaderApi from "../../services/header-apis";
import { StateContext } from "../../../../services/StateProvider";
import Globalization from "../../../../globalization/index";
import OutsideAlerter from "./header-outside";
import ManageAlerter from "./header-manage";
import ProfileAlerter from "./header-profile";
import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown';
import SettingsIcon from '@material-ui/icons/Settings';
import LoginApis from "../../../../scenes/login/services/LoginService";



const Header = (props) => {


  const history = useHistory();
  // GLOBAL ACCOUNT STATE management
  const [globalAccountState, globalAccountDispatch] = useContext(StateContext);
 const [logoutDialogOpen, setLogoutDialogOpen] = useState(false);
  const globalizationMapping = new Globalization();
  const globalHeaderTexts = globalizationMapping.HEADER;
  const locationPath = useLocation();

  const headerApi = new HeaderApi();
  const LoginApi = new LoginApis();
  // Handling the account and location information
  const account = globalAccountState.accountInfo.account;
  const location = globalAccountState.accountInfo.location;
  const locationCount = location.length;
  const EMTUSEROnly = globalAccountState?.accountInfo?.userProfile?.userRole === "EMTUSER";
  const hasEMTSUADMIN = globalAccountState?.accountInfo?.userProfile?.userRole?.includes("EMTSUADMIN");
  const hasEMTCADMIN = globalAccountState?.accountInfo?.userProfile?.userRole?.includes("EMTCADMIN");
  const hasEMTADMIN = globalAccountState?.accountInfo?.userProfile?.userRole?.includes("EMTADMIN");
 
  // Handling manage tires options
  const [showManageDropdown, setManageShowDropdown] = useState(false);
  const [showCreateDropdown, setCreateShowDropdown] = useState(false);

  const onClickManageTires = () => {
    setManageShowDropdown(!showManageDropdown);
    setCreateShowDropdown(false);
    setShowUserProfile(false);
  };

  const onClickCreateOptions = () => {
    setCreateShowDropdown(!showCreateDropdown);
    setManageShowDropdown(false);
    setShowUserProfile(false);
  };

  const onClickOutsideHeader = () => {
    setCreateShowDropdown(false);
  };
  const onClickManageHeader = () => {
    setManageShowDropdown(false);
  };
  const onClickProfileHeader = () => {
    setShowUserProfile(false);
  };
  // Handling user profile options
  const [showUserProfile, setShowUserProfile] = useState(false);
  const onClickUser = () => {
    setCreateShowDropdown(false);
    setManageShowDropdown(false);
    props.onClickHeader("user");
    setShowUserProfile(!showUserProfile);
  };

  const onClickHeaderOptions = (itemClicked) => {
    setCreateShowDropdown(false);
    setManageShowDropdown(false);
    setShowUserProfile(false);
    props.onClickHeader(itemClicked);
  };

  const onClickLogout = () => {
    setLogoutDialogOpen(true);
  };

  const handleLogoutConfirm = () => {
    setLogoutDialogOpen(false);
    // Add your logout logic here, e.g., clearing tokens, redirecting to login page, etc.


    LoginApi.logoutUser().then(() => {
      localStorage.clear();
      sessionStorage.clear();
      let currentUrl = window.location.href;
        let segments = currentUrl.split('/');
        let lastSegment = segments.pop();
  
        if (lastSegment !== 'login') {
          segments.push('login');
          let newUrl = segments.join('/');
          window.location.href = newUrl;
        }
    });

  };

  const handleLogoutCancel = () => {
    setLogoutDialogOpen(false);
  };

  const [accountInfo, setAccountInfo] = useState({
    show: false,
    currentPath: locationPath.pathname,
    account: account.accountName,
    location,
    locationCount
  });

  const showChangeModal = () => {
    setCreateShowDropdown(false);
    setManageShowDropdown(false);
    setShowUserProfile(false);
    setAccountInfo({
      show: true,
      currentPath: locationPath.pathname,
      account: accountInfo.account,
      location: accountInfo.location,
      locationCount: accountInfo.locationCount
    });
  };
  const hideChangeModal = () => {
    setAccountInfo({
      show: false,
      currentPath: locationPath.pathname,
      account: accountInfo.account,
      location: accountInfo.location,
      locationCount: accountInfo.locationCount
    });
  };

  // CONFIRMS THE CHANGED ACCOUNT AND LOCATION INFORMATION
  const confirmChangeAccount = (parentAccount, currentLocation, _setLocation) => {
    const currentLocationCount = currentLocation.length;
    // HANDLES THE ACCOUNT INFO STATE LOCALLY IN HEADER
    setAccountInfo({
      show: false,
      currentPath: locationPath.pathname,
      account: parentAccount.accountName,
      location: currentLocation,
      locationCount: currentLocationCount
    });

    // UPDATED ACCOUNT INFORMATION
    const userSetting = globalAccountState.accountInfo;
    const updatedAccountData = {
      account: parentAccount,
      location: currentLocation,
      userSetting: userSetting.userSetting,
      userProfile: userSetting.userProfile
    };

    setAccountData(updatedAccountData);
    // SENDING THE UDPATED STATE OF ACCOUNT INFO TO GLOBAL STATE
    globalAccountDispatch({ accountInfo: updatedAccountData, type: "UPDATE" });
    const req = {
      LastAccessedAccountId: updatedAccountData.account.accountId,
      LastAccessedLocationId: updatedAccountData.location[0].value
    }; 
    // *!* check the header api from multiple -> single location (issue: API only accept single location not array)
    headerApi.updateLastAccessed(req).then((_res) => { console.log("API call successful")});
    // CALL REFRESH FOR SETTING THE UPDATED DATA

    history.push("/home");
  };

  const isUnderHeaderNav = () => {
    switch (props.path) {
      case "reportsDashboard":
      case "scrapSummary":
      case "byRemovalReason":
      case "byCompound":
      case "byIndividualTire":
      case "scrapAnalysis":
      case "byTireType":
      case "byTireSize":
      case "scrapCostByTireSize":
      case "scrapHoursByTireSize":
      case "scrapCostByTireType":
      case "scrapHoursByTireType":
      case "monthlyTireLife":
      case "inServiceTireCostSummary":
      case "tireInstallation":
      case "tireHistory":
      case "byPercentageWorn":
      case "byWearCondition":
      case "byManufacturer":
      case "bySize":
      case "byTiresInServicesTireType":
      case "byVehicleId":
      case "projectedCostByTireSize":
      case "projectedCostByTireType":
      case "byVehicleModel":
      case "byVehicleWheelPosition":
      case "tireForecastByTireType":
      case "tireInflation":
      case "dailyJobSummary":
      case "tireNeedsForecast":
      case "tireRegister":
      case "tiresByDisposition":
      case "removedTire":
      case "tiresSentToRepair":
      case "tiresSentToRetread":
      case "tiresSentToInspectTireReport":
      case "newVSScrap":
      case "achievedHoursReport":
      case "allTireReport":
      case "fleetData":
      case "fleetSurvey":
      case "tireInflationReport":
      case "tireRotation":
      case "tireFlipping":
      case "tireForecast":
      case "rimReport":
      case "rimsInService":
      case "twoAxlesFourTires":
      case "twoAxlesSixTires":
      case "twoAxlesSixTiresTwo":
      case "twoAxlesEightTires":
      case "threeAxlesSixTires":
      case "threeAxlesTenTires":
      case "fourAxlesEightTires":
      case "fiveAxlesTenTires":
      case "fiveAxlesSixteenTires":
      case "fiveAxlesEighteenTires":
      case "fiveAxlesTwentyTires":
      case "sixAxlesTwelveTires":
      case "sevenAxlesFourteenTires":
      case "sevenAxlesTwentySixTires":
      case "eightAxlesSixteenTires":
      case "nineAxlesEighteenTires":
        return "header-title active-header-title"
      default:
        return "header-title"
    }
  }

  const classNameBaseOnPathCreate = () => {
    if (props.path === "create-vehicle" ||
        props.path === "createtire" ||
        props.path === "createparentaccount" ||
        props.path === "create-location" ||
        props.path === "createrim" ) {
      return "header-title-manage active-header-title"
    } else {
      return "header-title-manage"
    }
  }

  const classNameBaseOnPathManage = () => {
    if (props.path === "manage-vehicle" ||
        props.path === "manage-tire" ||
        props.path === "manage-parent-account" ||
        props.path === "manage-location" ||
        props.path === "manage-rim" ||
        props.path === "quick-inspect"||
        props.path === "view-vehicle") {
      return "header-title-manage active-header-title"
    } else {
      return "header-title-manage"
    }
  }

  const goToUserManagementPage = () => {
    history.push({ pathname: "/userManagementPage" });
  }

  return (
    <div>
      {/* DESKTOP VIEW  */}

      <div className="desktop-view-header">
        <AppBar position="static">
          <div className="header-container">
            <Grid container justify="space-evenly" wrap="nowrap">
                <Grid container item sm={1} md={1} lg={1} xl={1} justify="center">
                  <div className="header-logo-container">
                    <img src={require("../../../../assets/logo.svg")} className="emtrack-logo" alt="emtrack-logo" />
                  </div>
                </Grid>
              <Grid container item sm={7} md={7} lg={7} xl={7} spacing={1} justify="space-evenly" wrap="nowrap">
                <Grid container item sm={2} md={2} lg={2} xl={2} justify="center">
                  <div onClick={() => onClickHeaderOptions("home")} className={props.path === "home" ? "header-title active-header-title" : "header-title"}>
                    {globalHeaderTexts.HOME}
                  </div>
                </Grid>

                {/* Create Tire Drop-down */}
                <Grid container item sm={2} md={2} lg={2} xl={2} justify="center">
                  <OutsideAlerter onClickOutside={onClickOutsideHeader}>
                    <div className="create-dropdown" onClick={() => onClickCreateOptions()}>
                      <div className="dropdown-icon-container">
                        <div className={classNameBaseOnPathCreate()}>
                          <span>
                            {globalHeaderTexts.CREATE}
                            <KeyboardArrowDownIcon style={{verticalAlign:"middle"}}></KeyboardArrowDownIcon>
                          </span>
                        </div>
                      </div>
                      {showCreateDropdown && (
                        <div className="manage-dropdown-content">
                          <div onClick={() => onClickHeaderOptions("createvehicle")} className="manage-option">
                            {globalHeaderTexts.VEHICLE}
                          </div>
                          <Divider />
                          <div onClick={() => onClickHeaderOptions("createtire")} className="manage-option">
                            {globalHeaderTexts.TIRE}
                          </div>
                          <Divider />
                          <div onClick={() => onClickHeaderOptions("createrim")} className="manage-option">
                            {globalHeaderTexts.RIM}
                          </div>
                          { !EMTUSEROnly ? 
                            <>
                              <Divider />
                              <div onClick={() => onClickHeaderOptions("createparentacc")} className="manage-option">
                                {globalHeaderTexts.PARENTACC}
                              </div>
                              <Divider />
                              <div onClick={() => onClickHeaderOptions("createlocation")} className="manage-option">
                                {globalHeaderTexts.LOCATION}
                              </div>
                            </> : null}
                        </div>
                      )}
                    </div>
                  </OutsideAlerter>
                </Grid>

                <Grid container item sm={2} md={2} lg={2} xl={2} justify="center">
                  <ManageAlerter onClickOutside={onClickManageHeader}>
                    <div className="manage-dropdown" onClick={() => onClickManageTires()}>
                      <div className="dropdown-icon-container">
                        <div className={classNameBaseOnPathManage()}>
                          <span>
                            {globalHeaderTexts.MANAGE}
                            <KeyboardArrowDownIcon style={{verticalAlign:"middle"}}></KeyboardArrowDownIcon>
                          </span>
                        </div>
                      </div>
                      {showManageDropdown && (
                        <div className="manage-dropdown-content">
                          <div onClick={() => onClickHeaderOptions("managevehicle")} className="manage-option">
                            {globalHeaderTexts.MANAGEVEHICLE}
                          </div>
                          <Divider />
                          <div onClick={() => onClickHeaderOptions("managetire")} className="manage-option">
                            {globalHeaderTexts.MANAGETIRE}
                          </div>
                          <Divider />
                          <div onClick={() => onClickHeaderOptions("managerim")} className="manage-option">
                            {globalHeaderTexts.RIM}
                          </div>
                          { !EMTUSEROnly ? 
                          <>
                            <Divider />
                            <div onClick={() => onClickHeaderOptions("manageparentaccount")} className="manage-option">
                              {globalHeaderTexts.MANAGEPARENTACCOUNT}
                            </div>
                            <Divider />
                            <div onClick={() => onClickHeaderOptions("managelocation")} className="manage-option">
                              {globalHeaderTexts.MANAGELOCATION}
                            </div>
                            <Divider />
                          </> : null }
                        </div>
                      )}
                    </div>
                  </ManageAlerter>
                </Grid>
                <Grid item container sm={2} md={2} lg={2} xl={2} justify="center">
                  <div onClick={() => onClickHeaderOptions("reports")} className={isUnderHeaderNav()}>
                    {globalHeaderTexts.REPORTS}
                  </div>
                </Grid>
                <Grid container item sm={1} md={1} lg={1} xl={1} justify="center">
                  <div
                    style={{
                      paddingRight: globalHeaderTexts.HELP === "Aidez-moi" ? 0 : "inherit",
                      paddingLeft: !EMTUSEROnly && globalHeaderTexts.HELP === "Aidez-moi" ? 0 : "inherit"
                    }}
                    onClick={() => onClickHeaderOptions("help")}
                    className={props.path === "help" ? "header-title active-header-title" : "header-title"}
                  >
                    {globalHeaderTexts.HELP}
                  </div>
                </Grid>
                { EMTUSEROnly ? 
                  <Grid container item sm={2} md={2} lg={2} xl={2} justify="center">
                    <Tooltip title="Disabled due to user only status" placement="bottom" arrow>
                     <div className="header-title-manage-disabled" style={{
                         position:'relative',
                         display: 'flex',
                         marginTop: '7%',
                         fontSize: 'larger',
                         color: '#fbfbfb24',
                     }}>
                         {globalHeaderTexts.ADMIN}
                     </div>
                    </Tooltip>
                  </Grid> : 
                  <Grid container item sm={2} md={2} lg={2} xl={2} justify="center">
                    <div onClick={() => onClickHeaderOptions("admin")} className={props.path === "admin" ? "header-title active-header-title" : "header-title"}>
                      {globalHeaderTexts.ADMIN}
                    </div>
                  </Grid>
                }
                <Grid container item sm={2} md={2} lg={2} xl={2} justify="center">
                  <div onClick={() => onClickHeaderOptions("multireportsdata")} className={props.path === "multireportsdata" ? "header-title active-header-title" : "header-title"}>
                    {globalizationMapping.MULTIREPORTS.TITLE}
                  </div>
                </Grid>
              </Grid>

              <Grid container item sm={3} md={3} lg={3} xl={3} wrap="nowrap">
                
                  <Grid container item sm={10} md={10} lg={10} xl={10} style={{justifyContent: "flex-end"}}>
                    <button onClick={() => showChangeModal()} className="change-button">
                      <Grid item sm={12} className="parent-account-container">
                        <span className="account-header-text">{globalHeaderTexts.PARENTACC}: </span>
                        <span className="header-account-info-text">{globalAccountState.accountInfo.account.accountName}</span>
                      </Grid>
                      <Grid item sm={12} className="location-container">
                        <span className="account-header-text">{globalHeaderTexts.LOCATION}: </span>
                        <span className="header-account-info-text">
                          {locationCount === 1 ? location[0].label : globalAccountState.accountInfo.location.length + " " + globalHeaderTexts.LOCATIONSSELECTED}
                        </span>
                      </Grid>
                    </button>                 
                  </Grid>
                  <Grid container item sm={2} md={2} lg={2} xl={2} style={{marginLeft:10}}>
                    <button className="AssignmentInd-button" style={{paddingBottom:5}}>
                      <ProfileAlerter onClickOutside={onClickProfileHeader}>
                        <div className={showUserProfile === true ? "user-desktop-view user-background-clicked" : "user-desktop-view user-background"} onClick={() => onClickUser()}>
                          <SettingsIcon style={{fontSize:33}} className="AssignmentInd"></SettingsIcon >
                          {showUserProfile && (
                            <div className="user-dropdown-content">
                              <div onClick={() => onClickHeaderOptions("myprofile")} className="user-option">
                                {globalHeaderTexts.MYPROFILE}
                              </div>
                              <Divider />
                              <div onClick={() => onClickHeaderOptions("userpreference")} className="user-option">
                                {globalHeaderTexts.PREFERENCE}
                              </div>
                              <Divider />
                              {(hasEMTSUADMIN || hasEMTCADMIN) ? 
                                <>
                                  <div onClick={goToUserManagementPage} className="user-option">
                                    Go to User Management Page
                                  </div>
                                  <Divider /> 
                                </>: null}
                              
                              <div onClick={onClickLogout} className="user-option">
                                {globalHeaderTexts.LOGOUT}
                              </div>
                            </div>
                          )}
                        </div>
                      </ProfileAlerter>
                    </button>

                  
                </Grid>
                
              </Grid>
              <Grid container item justify="space-evenly" sm={1} md={1} lg={1} xl={1} wrap="nowrap">
                <div className="header-logo-container">
                  <img src={require("../../../../assets/goodyear-header-logo.svg")} style={{width:'100%', height:'auto', paddingTop:10}} alt="header-logo" />
                </div>
              </Grid>
            </Grid>
          </div>
        </AppBar>
      </div>

      <Dialog
        open={logoutDialogOpen}
        onClose={handleLogoutCancel}
        aria-labelledby="logout-dialog-title"
        aria-describedby="logout-dialog-description"
      >
        <DialogTitle id="logout-dialog-title">Confirm Logout</DialogTitle>
        <DialogContent>
          <DialogContentText id="logout-dialog-description">
            Are you sure you want to log out?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleLogoutCancel} color="primary">
            Cancel
          </Button>
          <Button onClick={handleLogoutConfirm} color="primary" autoFocus>
            Logout
          </Button>
        </DialogActions>
      </Dialog>

      <ChangeModal accountInfo={accountInfo} showChangeModal={showChangeModal} hideChangeModal={hideChangeModal} confirmChangeAccount={confirmChangeAccount} />
    </div>
  );
};

export default Header;
